<template>
  <div class="col-12 col-xl-3 order-1 order-xl-2 mb-5">
    <b>{{ $t('project.sort') }}:</b>
    <div class="form-group mt-3">
      <custom-select
        v-model="selectedModel"
        :options="options"
        :clearable="false"
        label="title"
        clear-search-on-select="true"
      ></custom-select>
    </div>
    <div class="d-flex gap-2">
      <a
        :href="$route.path"
        class="btn btn-block btn-outline-secondary btn-sm m-0"
      >
        {{ $t('project.reset') }}
      </a>
      <a
        :href="`${$route?.path}?${selectedModel?.type}=${selectedModel?.value}`"
        class="btn btn-block btn-sm btn-primary m-0"
      >
        {{ $t('project.search') }}
      </a>
    </div>
  </div>
</template>
<script>
import projectMessages from '../project.messages';
import CustomSelect from '@/shared-modules/shared-components/shared/custom-select';

export default {
  name: "ProjectFilterForm",
  components: { CustomSelect },
  data() {
    return {
      selectedModel: null,
      queryParams: this.$route.query,
      options: [
        {
          type: 'sortByProjectTitle',
          title: this.$t('projectSelect.project_sort_title_up'),
          value: 'true'
        },
        {
          type: 'sortByProjectTitle',
          title: this.$t('projectSelect.project_sort_title_down'),
          value: 'false'
        },
        {
          type: 'sortByUpdatedAt',
          title: this.$t('projectSelect.project_sort_time_up'),
          value: 'true'
        },
        {
          type: 'sortByUpdatedAt',
          title: this.$t('projectSelect.project_sort_time_down'),
          value: 'false'
        }
      ]
    };
  },
  beforeMount() {
    if (Object.keys(this.queryParams).length === 0 || this.queryParams?.page && Object.keys(this.queryParams).length === 1) {
      this.selectedModel = this.options.find(
        (option) => option?.type === 'sortByUpdatedAt' && option?.value == 'false'
      );
    } else {
      const searchCriteria = Object.entries(this.queryParams).find(([key, value]) => key === 'sortByUpdatedAt' || key === 'sortByProjectTitle' )

      this.selectedModel = this.options.find(
        (option) => option?.type == searchCriteria[0] && option?.value == searchCriteria[1]
      );
    }
  },
  i18n: {
    messages: projectMessages
  }
};
</script>
<style lang="">
</style>
